import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { CaseStudyCard } from "@/pages/Portfolio";

export const FeaturedWork = () => {
  const [cases, setCases] = useState([]);
  useEffect(() => { api.get("/case-studies", { params: { featured: true } }).then((r) => setCases(r.data.slice(0, 3))).catch(() => {}); }, []);
  if (!cases.length) return null;
  return (
    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20" data-testid="corp-featured-work">
      <div className="flex items-end justify-between gap-6 mb-10">
        <div>
          <span className="font-mono-tech text-xs uppercase tracking-[0.35em] text-[#C87455]">Featured work</span>
          <h2 className="font-serif-display font-light text-2xl md:text-4xl text-white tracking-tight mt-3">How these packages come together</h2>
        </div>
        <Link to="/portfolio" data-testid="featured-work-all" className="link-line hidden sm:block font-mono-tech text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-white">All case studies →</Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {cases.map((cs, i) => <CaseStudyCard key={cs.id} cs={cs} index={i} />)}
      </div>
      <Link to="/portfolio" className="sm:hidden inline-block mt-6 font-mono-tech text-xs uppercase tracking-[0.2em] text-[#C87455]">All case studies →</Link>
    </section>
  );
};
